export default __webpack_public_path__ + "media/images/brands/garden-trading-d34e902725aeedd580121df9d915cad0.png";